
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.156 3.797a.422.422 0 00.422-.422V.844a.422.422 0 00-.422-.422h-2.531a.422.422 0 00-.422.422v.844H3.797V.844a.422.422 0 00-.422-.422H.844a.422.422 0 00-.422.422v2.531a.422.422 0 00.422.422h.844v19.406H.844a.422.422 0 00-.422.422v2.531a.422.422 0 00.422.422h2.531a.422.422 0 00.422-.422v-.843h19.406v.843a.422.422 0 00.422.422h2.531a.422.422 0 00.422-.422v-2.531a.422.422 0 00-.422-.422h-.843V3.797h.843zm-24.89-.844V1.266h1.687v1.687H1.266zm1.687 22.781H1.266v-1.687h1.687v1.687zm20.25-2.109v.844H3.797v-.844a.422.422 0 00-.422-.422h-.844V3.797h.844a.422.422 0 00.422-.422v-.844h19.406v.844a.422.422 0 00.422.422h.844v19.406h-.844a.422.422 0 00-.422.422zm2.531.422v1.687h-1.687v-1.687h1.687zM24.047 2.953V1.266h1.687v1.687h-1.687z","fill":"#43B4EB"}}),_c('path',{attrs:{"d":"M23.203 5.906H3.797a.422.422 0 00-.422.422v14.344a.422.422 0 00.422.422h19.406a.422.422 0 00.422-.422V6.328a.422.422 0 00-.422-.422zM4.22 20.25v-.476l4.64-6.006 5.01 6.482h-9.65zm18.562 0h-7.847l-2.289-2.963L18.3 9.971l4.482 5.8v4.479zm0-5.858l-4.148-5.369a.422.422 0 00-.668 0l-5.853 7.575-2.919-3.778a.422.422 0 00-.667 0l-4.307 5.574V6.75H22.78v7.642z","fill":"#43B4EB"}}),_c('path',{attrs:{"d":"M8.86 11.813a2.11 2.11 0 100-4.22 2.11 2.11 0 000 4.22zm0-3.376a1.266 1.266 0 110 2.532 1.266 1.266 0 010-2.531z","fill":"#43B4EB"}})])
          )
        }
      }
    